<template>
  <div>
<!--    <div class="images-block">-->
<!--      <img v-for="(item, index) in imagesList" :src="item" :key="index" width="350" height="465">-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      // imagesList: [
      //   'https://sixfish-scrm-oss.oss-cn-hangzhou.aliyuncs.com/images/kefu01.png',
      //   'https://sixfish-scrm-oss.oss-cn-hangzhou.aliyuncs.com/images/kefu02.png',
      //   'https://sixfish-scrm-oss.oss-cn-hangzhou.aliyuncs.com/images/kefu03.png',
      // ]
    };
  },
  created() {
  },
  methods:{
  }
};
</script>
<style>
  .images-block img {
    margin-top: 10px;
    margin-left: 50px;
  }

</style>
